import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.8351 2.24794C17.5045 1.91735 16.9685 1.91735 16.638 2.24794L2.24794 16.638C1.91735 16.9685 1.91735 17.5045 2.24794 17.8351C2.57849 18.1657 3.11448 18.1657 3.44502 17.8351L9.19503 12.0851V15.5436H7.54741C7.07995 15.5436 6.70094 15.9225 6.70094 16.3901C6.70094 16.8576 7.07995 17.2365 7.54741 17.2365H10.0415H10.0429H12.5356C13.0031 17.2365 13.3821 16.8576 13.3821 16.3901C13.3821 15.9225 13.0031 15.5436 12.5356 15.5436H10.888V10.3921L15.5685 5.71158C15.6601 6.08014 15.9932 6.35329 16.3901 6.35329C16.8576 6.35329 17.2365 5.97433 17.2365 5.50682V5.05337C17.2365 4.75477 17.1772 4.47006 17.0698 4.21032L17.8351 3.44502C18.1657 3.11448 18.1657 2.57849 17.8351 2.24794Z"
      fill="#7876C1"
    />
    <path
      d="M11.1899 4.63973V5.98265L9.45477 7.67634V4.63973H5.20993C4.91903 4.63973 4.68319 4.86995 4.68319 5.15389V5.60755C4.68319 6.07526 4.29478 6.45439 3.81563 6.45439C3.33648 6.45439 2.94807 6.07526 2.94807 5.60755V5.15389C2.94807 3.93452 3.96073 2.94604 5.20993 2.94604H14.3008L12.5657 4.63973H11.1899Z"
      fill="#7876C1"
    />
  </svg>
);

const TextCrossIcon = (props) => <Icon component={svg} {...props} />;

export default TextCrossIcon;
